import { Row, Col, Button } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import DataGrid from 'components/theme_components/DataGrid';
import HeroTitle from 'components/theme_components/HeroTitle';
import DF from 'DisplayFramework';
import {
  DownloadOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import React, { useRef, useContext, useState, useCallback } from 'react';
import { FilterConfig } from 'types';
import { useQuery } from 'react-query';
import {
  getConversionRuleById,
  getConversionRuleListByCriteria,
  deleteConversionRule,
} from 'services/parametersService';

import GetLabel from 'DisplayFramework/components/GetLabel';
import ParRuleModal from './ParRuleModal';
import ModalSFS from 'components/theme_components/ModalSFS';
import IPen from 'icons/IPen';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import { AuthContext } from 'components/Auth/Auth';
import IBasket from 'icons/IBasket';
import { getProductList } from 'services/parametersService';
import Notifications from 'components/theme_components/Notifications';

// Interfaces
export interface ProductConversionRuleRequest {
  sourcePrcode: string;
  targetPrcode: string;
  isAuthorized: boolean;
}

export interface ProductConversionRuleResponse {
  rulid: number;
  sourcePrcode: string;
  targetPrcode: string;
  isAuthorized: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

export type ParRuleListProps = {
  color: string;
};

const ParRuleList = (props: ParRuleListProps) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedRows, setSelectedRows] = useState<ProductConversionRuleResponse[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = useForm();
  
  const { data: productsData, isLoading } = useQuery(
    'productList',
    () => getProductList().then(res => res.list || [])
  );
  
  const initialSearchParams = {
    sourcePrcode: '',
    targetPrcode: '',
    isAuthorized: '',
  };
  
  const { isInspect } = useContext(AuthContext);
  const [modalVisibleDelet, setmodalVisibleDelete] = useState(false);
  const [searchParams, setSearchParams] = useState<any>(initialSearchParams);
  const [editingRecord, setEditingRecord] = useState<ProductConversionRuleResponse | null>(null);
  const getSearchParams = (values: any) => {
  const params: any = {};
  Object.entries(values).forEach(([key, value]) => {
    // This condition should work for booleans
   // if (typeof value === 'boolean' || (value !== undefined && value !== null && value !== '')) {
      params[key] = value;
   // }
  });
  return params;
};

  const prepareSearchParams = useCallback((params: any) => {
  const prepared: Record<string, any> = {};

  Object.entries(params).forEach(([key, value]) => {
    // Only process values that are not undefined, null, or empty string
    if (value !== undefined && value !== null && value !== '') {
      if (key === 'isAuthorized') {
        if (value === 'true') prepared.isAuthorized = true;
        else if (value === 'false') prepared.isAuthorized = false;
      } else {
        prepared[key] = value;
      }
    }
  });

  return prepared;
}, []);

 // const { data: conversionRules, isFetching, refetch } = useQuery(
  //  ['conversionRules', searchParams],
  //  () => getConversionRuleListByCriteria(prepareSearchParams(searchParams)).then(res => res.list || []),
  //  { enabled: true }
 // );

const { data: conversionRules, isFetching, refetch } = useQuery(
  ['conversionRules', JSON.stringify(searchParams)], 
  () => {
    console.log('API call with params:', searchParams);
    return getConversionRuleListByCriteria(prepareSearchParams(searchParams)).then(res => res.list || []);
  },
  { 
    enabled: true,
    refetchOnMount: true 
  }
);

  const filterConfig: FilterConfig[] = [
  {
    key: 'sourcePrcode',
    label: 'activityproductSource',
    type: 'text',
    placeholder: 'activityproductSource',
  },
  {
    key: 'targetPrcode',
    label: 'activityproductDestinaire',
    type: 'text',
    placeholder: 'activityproductDestinaire',
  },
   {
  key: 'isAuthorized',
  label: 'Autorisation',
  type: 'select',
  placeholder: 'Sélectionner...',
  options: [
    { label: 'Tous', value: '' },
    { label: 'Oui', value: 'true' },
    { label: 'Non', value: 'false' },
  ],
  },
];

const handleEdit = (record: ProductConversionRuleResponse) => {
  setEditingRecord(record);
};

  const columns = [
    {
      title: 'Produit Source',
      dataIndex: 'sourcePrcode',
      key: 'sourcePrcode',
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: 'Produit Destination',
      dataIndex: 'targetPrcode',
      key: 'targetPrcode',
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: 'Authorisation',
      dataIndex: 'isAuthorized',
      key: 'isAuthorized',
      render: (val: boolean) => <div>{val ? 'Oui' : 'Non'}</div>,
    },
    {
      title: 'Actions',
      key: 'update',
   render: (record: ProductConversionRuleResponse) => (
    <ModalSFS
      className="color-gray"
      trigger={({ setVisible }) => (
        <IPen onClick={() => {
          if (!isInspect) {
            handleEdit(record);
            setVisible(true);
          }
        }} />
      )}
      title="editRule"
      footer
      width={560}
    >
      <ParRuleModal 
        mode="modify" 
        editData={editingRecord}
         onSuccess={refetch}
        setVisible={(visible) => {
          if (!visible) {
            setEditingRecord(null);
            refetch();
          }
        }} 
      />
    </ModalSFS>
  ),
    },
  ];

  const onSelectChange = (keys: React.Key[], rows: ProductConversionRuleResponse[]) => {
    
    setSelectedRowKeys(keys);
    setSelectedRows(rows);
    setIsDisabled(keys.length === 0);
  };

  const handleDeleteConfirm = async () => {
    
    if (selectedRows.length === 0) {
      console.error('No rows selected for deletion');
      Notifications({
        status: 'error',
        message: 'Aucune règle sélectionnée',
        duration: 2,
        placement: 'top',
      });
      setmodalVisibleDelete(false);
      return;
    }

    try {
      // Process deletions sequentially to avoid overwhelming the server
      for (const rule of selectedRows) {
      
        
        if (!rule || rule.rulid === undefined || rule.rulid === null) {
          console.error('Rule or Rule ID is undefined/null:', { rule, rulid: rule?.rulid });
          Notifications({
            status: 'error',
            message: 'Erreur: ID de règle manquant',
            duration: 2,
            placement: 'top',
          });
          continue;
        }
        
        try {
          //console.log('Making DELETE request with ID:', rule.rulid);
          const ruleid =rule.rulid;
          const response = await deleteConversionRule({id:ruleid});
          if (response.code === '200') {
            Notifications({
              status: 'success',
              message: `Règle supprimée`,
              duration: 2,
              placement: 'top',
            });
          } else {
            Notifications({
              status: 'error',
              message: response.message || 'Erreur lors de la suppression',
              duration: 2,
              placement: 'top',
            });
          }
        } catch (error) {
          console.error('Delete error for rule:', rule.rulid, error);
          Notifications({
            status: 'error',
            message: `Erreur lors de la suppression de la règle ${rule.rulid}`,
            duration: 2,
            placement: 'top',
          });
        }
      }
      
      // Refetch data and clear selection
      await refetch();
      setSelectedRows([]);
      setSelectedRowKeys([]);
      setIsDisabled(true);
    } catch (error) {
      console.error('General delete error:', error);
      Notifications({
        status: 'error',
        message: 'Erreur générale lors de la suppression',
        duration: 2,
        placement: 'top',
      });
    } finally {
      setmodalVisibleDelete(false);
    }
  };

  return (
    <DF.Provider pagcode="productlist">
      <div className="bg-color-gray">
        <HeroTitle
          form={form}
          color={props.color}
          title="parRuleList"
          showFilter
          display
          filterConfig={filterConfig}
// In your onFilterSearch callback:
onFilterSearch={(values) => {
  console.log('Filter values received:', values);
  // 🔍 Ajoute ce log ici pour voir le type exact
  console.log('✅ isAuthorized typeof:', typeof values.isAuthorized, values.isAuthorized);
  // Map the form field names to API field names
 
  const mappedValues = {
    sourcePrcode: values.sourcePrcode,
    targetPrcode: values.targetPrcode,
    isAuthorized:
      values.isAuthorized === true || values.isAuthorized === 'true'
        ? 'true'
        : values.isAuthorized === false || values.isAuthorized === 'false'
        ? 'false'
        : undefined,
  };
  
  const preparedParams = getSearchParams(mappedValues);
  console.log('Mapped values:', mappedValues);
  setSearchParams(preparedParams);
}
} onFilterReset={() => setSearchParams(initialSearchParams)}
          className="productlist"
          noTitleOverlay
        />

        <div className="ut-title-page no-after">
          <Row justify="space-between" align="middle" style={{ marginBottom: '15px' }}>
            <Col className="d-flex justify-start align-center">
              <Button
                disabled={isDisabled}
                className={
                  !isDisabled ? 'no-border-radius btn-header ant-btn-outline-primary bg-color-hover' : 'no-border-radius btn-header'
                }
                onClick={() => !isInspect && setmodalVisibleDelete(true)}
                icon={<IBasket color={isDisabled ? '#d9d9d9' : '#dd7248'} className="font-size-25" />}
              >
                <GetLabel label="deletRule" /> ({selectedRows.length})
              </Button>
              
              <ModalSFS
                className="color-gray"
                trigger={({ setVisible }) => (
                  <Button
                    className="no-border-radius ant-btn-outline-primary ml-2 filter-item ant-btn-add bg-color-hover"
                    onClick={() => !isInspect && setVisible(true)}
                    icon={<PlusOutlined />}
                  >
                    <GetLabel label="addRule" />
                  </Button>
                )}
                title="addRule"
                footer
                width={560}
              >
                <ParRuleModal mode="create" onSuccess={refetch} setVisible={() => false} />
              </ModalSFS>
            </Col>
            
            <Col span={5} className="d-flex justify-end align-center">
              <Button
                onClick={() => {}}
                className="ut-reset-btn ut-btn-no-border no-box-shadow"
                icon={<DownloadOutlined />}
              >
                <GetLabel label="Exporter(.xls)" className="color-blue font-weight-500" />
              </Button>
            </Col>
          </Row>

          <DataGrid
            columns={columns}
            dataSource={conversionRules}
            rowKey="rulid"
            hideFilters
            hideTitle
            isLoading={isFetching}
            rowSelection={{ 
              type: 'checkbox', 
              onChange: onSelectChange, 
              selectedRowKeys,
              getCheckboxProps: (record: ProductConversionRuleResponse) => ({
                disabled: false,
                name: record.rulid.toString(),
              }),
              // Add this to ensure we get the full record
              onSelect: (record: ProductConversionRuleResponse, selected: boolean, selectedRows: ProductConversionRuleResponse[]) => {
                             },
              onSelectAll: (selected: boolean, selectedRows: ProductConversionRuleResponse[], changeRows: ProductConversionRuleResponse[]) => {
             
              },
            }}
            pagination={{
              pageSize: 10,
              showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total}`,
              showSizeChanger: true,
            }}
          />
        </div>

        <ConfirmModal
          className="modalConfirmOrCancel"
          visible={modalVisibleDelet}
          status="error"
          message="Êtes-vous sûr de vouloir supprimer cette règle ?"
          onConfirm={handleDeleteConfirm}
          onCancel={() => {
            !isInspect && setmodalVisibleDelete(false);
          }}
          Confirmcomcode="valider"
          Cancelcomcode="close"
        />
      </div>
    </DF.Provider>
  );
};

export default ParRuleList;